import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from '../data.service';

@Component({
  selector: 'app-blockcard',
  templateUrl: './blockcard.component.html',
  styleUrls: ['./blockcard.component.scss']
})
export class BlockcardComponent implements OnInit {

  constructor(private data:DataService,private router:Router) { }
  public errMessage:string;
  ngOnInit(): void {
  }

  onBlockCard(): void{
    this.data.request<string>("kiosk/blockcard",null,"GET").subscribe((v) => {
      this.data.token = "";
      this.data.SelectedProperty = null;
      this.data.SelectedCardNumber = "";
      this.data.SelectedCardBearerID = "";
      this.data.isLoggedIn = false;
      this.data.RaiseEvent("logout");
    },(error)=>{
      this.errMessage = "Failed to block the card, please contact support";
    });
    
  }

  onCancel() : void {
    history.back();
  }
}
